<template>
  <div class="no_data_box">
    <p><slot /></p>
    <div v-show="!isVip">
      <p>立即获得VIP服务，畅享一站式精品内容无限下载特权</p>
      <Button class="btn colorful_btn" @click="buyVip">成为会员</Button>
    </div>
  </div>
</template>

<script>
import Button from '@shared/components/Button/Button.vue'

import { reportAction } from '@/report/index.js'

export default {
  name: 'NoData',

  components: { Button },

  props: {
    area: {
      type: Number,
      default: null
    }
  },

  computed: {
    isVip () {
      return this.$store.getters.isVip
    }
  },

  methods: {
    buyVip () {
      reportAction({ actiontype: 2, area: this.area, pos: '' })
      this.$store.dispatch('openMemberDialog')
    }
  }
}
</script>

<style lang="scss" scoped>
.no_data_box { width: 500px; padding-top: 265px; margin: auto; font-size: 18px; font-weight: 500; line-height: 36px; color: #666; text-align: center;
  .btn { margin-top: 53px; }
}
</style>
